import React from 'react';
import Sidebar from '../SideBar';
import Wishlist from './Wishlist';
import Navbar from '../../NavBar';
import Footer from '../../Footer';
import SectionBreak from '../../SectionBreak';

const WishlistPage = () => {
  return (
    <>
      <Navbar />
      <SectionBreak />
      <div className="flex flex-col md:flex-row min-h-screen bg-white pt-[80px]">
        <div className="w-full md:w-64 flex-shrink-0">
          <Sidebar />
        </div>
        <div className="flex-grow flex items-start justify-center">
          <Wishlist />
        </div>
      </div>
      <SectionBreak />
      <Footer />
    </>
  );
};

export default WishlistPage;